import { useEffect } from 'react';

const domainToLanguage = {
  'www.ving.se': 'se',
  'www.ving.no': 'no',
  'www.spies.dk': 'dk',
  'www.tjareborg.fi': 'fi',
  'www.globetrotter.se': 'se',
  localhost: 'en',
};

const languageToText = {
  se: 'Godkänn funktionella kakor för att starta chatten',
  no: 'Godta funksjonelle informasjonskapsler for å starte chatten',
  dk: 'Accepter funktionelle cookies for at starte chatten',
  fi: 'Hyväksy toiminnalliset evästeet, jotta voit aloittaa chatin',
  en: 'Accept functional cookies to start the chat',
};

function waitForElement(selector, callback) {
  const el = document.querySelector(selector);
  if (el) {
    callback();
  } else {
    requestAnimationFrame(() => waitForElement(selector, callback));
  }
}

function injectConsentLinkWhenNeeded() {
  const hasConcentForChat = window.CookieInformation?.getConsentGivenFor('cookie_cat_functional');
  console.log(`[chat] Has consent for chat: ${hasConcentForChat}`);

  // only add consent link when consent is not given for chat
  if (hasConcentForChat) {
    return;
  }

  // add style
  const style = document.createElement('style');
  style.textContent = `
    .hax-hover-underline { 
      text-decoration: none;
      text-underline-offset: 2px
      } 
    .hax-hover-underline:hover { text-decoration: underline; } 
  `;
  document.head.appendChild(style);

  // add link
  const container = document.getElementById('faq-contact-app');
  const ul = container.querySelector('.humany-list');
  const li = document.createElement('li');
  const div = document.createElement('div');
  const a = document.createElement('a');
  a.classList.add('hax-hover-underline');
  // create link url
  const url = new URL(window.location);
  url.searchParams.set('consent', 'change');
  a.href = url.search; // only add querystring to existing url
  // set link text
  const domain = window.location.hostname;
  const language = domainToLanguage[domain] || 'en';
  const text = languageToText[language];
  a.textContent = text;

  ul.appendChild(li);
  li.appendChild(div);
  div.appendChild(a);
}

const TeliaACEKnowledgeContactHax = () => {
  // useEffect will only run on the client-side after component mounts
  useEffect(() => {
    waitForElement('.faq-contact-container ul.humany-list', injectConsentLinkWhenNeeded);
  }, []);

  // on server the component only return null
  return null;
};

export default TeliaACEKnowledgeContactHax;
